import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "station-banner-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 pb-5"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]

import { computed, onMounted, onUnmounted, reactive, watch } from "vue";
import { checkIfStationPdfExists } from "@/stationPdf/checkIfStationPdfExits.js";
import { CustomWindowEvents } from "@/enums/customWindowEvents";
import summerBannerDesktopImg from "@/images/bannerDesktopSummer.png";
import summerBannerMobileImg from "@/images/bannerMobileSummer.png";
import winterBannerDesktopImg from "@/images/bannerDesktopWinter.png";
import winterBannerMobileImg from "@/images/bannerMobileWinter.png";

type ScreenType = "desktop" | "tablet" | "mobile" | string;
type StationPdfLink = string;


export default /*@__PURE__*/_defineComponent({
  __name: 'StationBanner',
  props: {
    parentStationId: {},
    stationId: {}
  },
  setup(__props: any) {

const props = __props;

const w = window as Window & {
  seasonManager?: { season?: string };
  screenSizeManager?: { screenType?: ScreenType };
};

const state = reactive({
  currentScreenSize: w.screenSizeManager?.screenType ?? ("desktop" as ScreenType),
  currentSeason: w.seasonManager?.season ?? "",
  doesStationPdfExists: false,
  pdfLink: "" as StationPdfLink,
});

const isCurrentSeasonSummer = computed(() => state.currentSeason === "E");

const isMobileScreenSize = computed(() => state.currentScreenSize === "mobile");

const bannerImgSrc = computed(() => {
  const isSummer = isCurrentSeasonSummer.value;
  const isMobile = isMobileScreenSize.value;

  if (isSummer) {
    return isMobile ? summerBannerMobileImg : summerBannerDesktopImg;
  }

  return isMobile ? winterBannerMobileImg : winterBannerDesktopImg;
});

async function getStationBannerPdf() {
  const pdfContentLink = await checkIfStationPdfExists({
    stationId: props.stationId,
    parentStationId: props.parentStationId,
    isSummer: isCurrentSeasonSummer.value,
  });

  if (pdfContentLink) {
    state.doesStationPdfExists = true;
    state.pdfLink = pdfContentLink;
  } else {
    state.doesStationPdfExists = false;
    state.pdfLink = "";
  }
}

function onScreenTypeChange() {
  const screenType = w.screenSizeManager?.screenType;
  if (screenType) state.currentScreenSize = screenType;
}

async function onSeasonChange() {
  state.currentSeason = w.seasonManager?.season ?? "";
  await getStationBannerPdf();
}

onMounted(async () => {
  state.currentSeason = w.seasonManager?.season ?? "";
  await getStationBannerPdf();
  window.addEventListener("screenTypeChange", onScreenTypeChange);
  window.addEventListener(CustomWindowEvents.CHANGE_SEASON, onSeasonChange);
});

watch(
  () => [props.stationId, props.parentStationId] as const,
  async () => {
    await getStationBannerPdf();
  }
);

onUnmounted(() => {
  window.removeEventListener("screenTypeChange", onScreenTypeChange);
  window.removeEventListener(CustomWindowEvents.CHANGE_SEASON, onSeasonChange);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (state.doesStationPdfExists)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            href: state.pdfLink,
            target: "_blank"
          }, [
            _createElementVNode("img", {
              src: bannerImgSrc.value,
              loading: "lazy",
              class: "w-100"
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})